import React from 'react';

const NewsSectionTwo = () => {
  const newsItems = [
    {
      id: 1,
      image: '/assets/images/resource/news-4.jpg',
      date: '26',
      month: 'Nov',
      comments: 2,
      title: 'Get Easily Abroad Study Visa Approval Now',
      link: 'news-details.html',
    },
    {
      id: 2,
      image: '/assets/images/resource/news-5.jpg',
      date: '26',
      month: 'Nov',
      comments: 2,
      title: 'Get Easily Abroad Study Visa Approval Now',
      link: 'news-details.html',
    },
    {
      id: 3,
      image: '/assets/images/resource/news-6.jpg',
      date: '26',
      month: 'Nov',
      comments: 2,
      title: 'Get Easily Abroad Study Visa Approval Now',
      link: 'news-details.html',
    },
  ];

  return (
    <section className="news-section-two">
      <div className="anim-icons">
        <span className="icon icon-object-1"></span>
        <span className="icon icon-shape-4"></span>
      </div>
      <div className="auto-container">
        <div className="sec-title text-center">
          <span className="sub-title">güncel haberler</span>
          <h2>
            Latest News &amp; Articles <br />
            From the Blog.
          </h2>
        </div>
        <div className="row">
          {newsItems.map((item, index) => (
            <div
              key={item.id}
              className={`news-block-two col-lg-4 col-md-6 col-sm-12 wow fadeInUp`}
              data-wow-delay={`${index * 300}ms`}
            >
              <div className="inner-box">
                <div className="image-box">
                  <figure className="image">
                    <a href={item.link}>
                      <img src={item.image} alt={`news-${item.id}`} />
                    </a>
                  </figure>
                  <span className="date">
                    <b>{item.date}</b> {item.month}
                  </span>
                </div>
                <div className="content-box">
                  <ul className="post-info">
                    <li>
                      <i className="fa fa-comments"></i> {item.comments} Comments
                    </li>
                  </ul>
                  <h4 className="title">
                    <a href={item.link}>{item.title}</a>
                  </h4>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default NewsSectionTwo;